import TimeTableShortCodeDocs from './shortcodes/TimeTableShortCodeDocs'

type Props = {}

const TimeTableDoc = (props: Props) => {
  return (
    <div>
      <TimeTableShortCodeDocs />
    </div>
  )
}

export default TimeTableDoc